/* src/app/main-layout/main-layout/main-layout.component.css */
.main {
  overflow: scroll;
  padding-top: calc(var(--spacing, 0.25rem) * 14);
  padding-left: 6.25rem;
}
.main-shell {
  display: flex;
  height: 90vh;
  min-height: 100vh;
  flex-direction: column;
}
.main-content {
  flex: 1;
  align-self: stretch;
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  padding-top: calc(var(--spacing, 0.25rem) * 6);
  padding-bottom: calc(var(--spacing, 0.25rem) * 13);
}
@media (width >= 48rem) {
  .main-content {
    padding-bottom: calc(var(--spacing, 0.25rem) * 11);
  }
}
@media (width >= 64rem) {
  .main-content {
    padding-inline: calc(var(--spacing, 0.25rem) * 7);
  }
}
@media (width >= 64rem) {
  .main-content {
    padding-bottom: calc(var(--spacing, 0.25rem) * 6);
  }
}
.main-inner {
  flex: 1;
}
@media (width <= 991px) {
  .main {
    padding-left: calc(var(--spacing, 0.25rem) * 10);
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=main-layout.component.css.map */
